import React from "react";
import { Navbar, Nav, Container, NavbarBrand, NavItem, NavLink, Button } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../../hooks/useTranslation";

const ClientNavbar = (props) => {
  const t = useTranslation();
  const location = useLocation();
  const { brandText, logo } = props;

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <Navbar className="client-navbar navbar-expand-lg navbar-dark bg-dark" expand="lg" fixed="top">
      <Container>
        <NavbarBrand tag={Link} to="/" className="d-flex align-items-center">
          {logo && logo.imgSrc ? (
            <img
              alt="logo"
              className="navbar-brand-img mr-2"
              src={logo.imgSrc}
              style={{ height: "45px" }}
            />
          ) : null}
          <span className="font-weight-bold" style={{ fontSize: "1.5rem" }}>
            {brandText || logo?.text || "Black & White"}
          </span>
        </NavbarBrand>
        <Nav navbar className="ml-auto align-items-center" id="navigation">
          <NavItem>
            <NavLink 
              tag={Link} 
              to="/"
              className={isActive("/") ? "active" : ""}
              style={{ fontWeight: isActive("/") ? "bold" : "normal" }}
            >
              {t("client.home") || "Home"}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink 
              tag={Link} 
              to="/products"
              className={isActive("/products") ? "active" : ""}
              style={{ fontWeight: isActive("/products") ? "bold" : "normal" }}
            >
              {t("client.products") || "Products"}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink 
              tag={Link} 
              to="/about"
              className={isActive("/about") ? "active" : ""}
              style={{ fontWeight: isActive("/about") ? "bold" : "normal" }}
            >
              {t("client.about") || "About"}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink 
              tag={Link} 
              to="/contact"
              className={isActive("/contact") ? "active" : ""}
              style={{ fontWeight: isActive("/contact") ? "bold" : "normal" }}
            >
              {t("client.contact") || "Contact"}
            </NavLink>
          </NavItem>
          <NavItem className="ml-3">
            <Button 
              tag={Link} 
              to="/admin/login" 
              color="primary" 
              size="sm"
              className="px-3"
            >
              {t("client.login") || "Login"}
            </Button>
          </NavItem>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default ClientNavbar;

